import { UIStateContextValue } from './types';

export const defaultContextValue: UIStateContextValue = {
    isDisabled: false,
    isReadonly: false,
    isLoading: false,

    wrapWithLoading: (promise) => promise,
};